import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {Alert, Button, message, Popconfirm, Spin, Switch, Table, Tag, Tooltip, Modal} from 'antd';
import {connect} from 'react-redux'
import classnames from 'classnames'

import {deleteCard, getCards, setCardDefault} from '../../../actions/paymentActions'
import moment from 'moment';

class CardSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [],
      loading: false,
      set_card_default_loading: false,
    }
  }

  setCardDefault = (card_id) => {


    this.setState({set_card_default_loading: true})

    this.props.setCardDefault(card_id)


  }

  goTo(route) {
    this.props.history.replace(`${route}`)
  }

  componentWillMount() {

    this.setState({loading: true})

    this.props.getCards()

  }

  componentWillReceiveProps(props) {
    this.setState({loading: false, set_card_default_loading: false})
  }


  deleteCard = (card_id, isDelete) => {
    this.setState({set_card_default_loading: true})

    deleteCard(card_id, {isDelete}).then(res => {
      message.success('Your card has been successfully deleted.')

      this.props.getCards();
    }).catch(err => {

      console.log('err', err.response);
      message.error(err.response ? err.response.data.message : 'Something went wrong')
    }).finally(() => {
      this.setState({set_card_default_loading: false})
    })

  }


  render() {

    const AlertStyle = {
      padding: 100,
      textAlign: 'center',
      marginBottom: 10,
      background: "#ffffff",
      border: "1px solid #ddd"
    }

    const CardList = () => {
      const columns = [{
        title: 'No',
        dataIndex: 'no',
        // render: text => <a href="#">{text}</a>,
      }, {
        title: 'Card Type',
        dataIndex: 'card_type',
      }

        ,
        {
          title: 'Card Number',
          dataIndex: 'last_four_digits',
        }
        , {
          title: 'Added At',
          dataIndex: 'addedAt',
        }, {
          title: 'Card Default',
          dataIndex: 'card_default',
        },
        {
          title: 'Active',
          dataIndex: 'active',
        }, {
          title: 'Action',
          dataIndex: 'action',
        }];

      let data_cards = this.props.cards.map((card, index) => {

        return {
          key: card._id,
          no: index + 1,
          card_type: card.cardType,
          last_four_digits: '*************' + card.lastFourDigits,
          active: (card.isActive) ? (<Tag color="#87d068">Active</Tag>) : (<Tag>Inactive</Tag>),
          card_default: (
            <Tooltip placement="top" title={'set this card to Default'}>
              <Popconfirm
                title={<div>
                  <p>ATTENTION::</p>
                  <p>If you change the default card, all past or future bookings will use the new default card</p>
                </div>
                }
                onConfirm={() => this.setCardDefault(card._id)}
                onCancel={() => console.log('cancel - set - default card')}
                okText="Yes"
                cancelText="Cancel"
                className="pop-confirm-try-again"
              >
                <Switch
                  className={classnames({default_card: card.isDefault})}
                  checked={card.isDefault}
                />
              </Popconfirm>

            </Tooltip>
          ),
          addedAt: moment(card.addedAt).format('LLL'),
          action: card.isDefault ?
            <Popconfirm
              title="ATTENTION: This is your default card on file.  If you have any pending or accepted booking requests, deleting this card may cancel all pending and accepted booking requests.  Are you sure you want to proceed?  If you don't want to cancel your bookings, please click 'No' and add or choose a new default card before deleting this payment method."
              onConfirm={() => {
                this.deleteCard(card._id, true)
              }}
              okText="Yes"
              cancelText="No"
            >
              <a>Delete</a>
            </Popconfirm> :
            <Popconfirm
              title="Are you sure you want to delete this card?"
              onConfirm={() => this.deleteCard(card._id,false)}
              onCancel={() => console.log('cancel - delete -card')}
              okText="Yes"
              cancelText="Cancel"
              className="pop-confirm-try-again"
            >
              <a>Delete</a>
            </Popconfirm>
        }
      })

      return <Table columns={columns} dataSource={data_cards}/>

    }


    return (
      <div>

        {(this.state.loading) && (
          <div style={{
            textAlign: "center",
            padding: "60px 0"
          }}><Spin></Spin></div>
        )}
        {
          (!this.state.loading) && ((this.props.cards.length == 0) ? (
              <Alert style={AlertStyle} message="No Cards Found" type="info"/>) : (
              <div className={classnames({loading_card: this.state.set_card_default_loading})}><CardList/><Spin className="spin_loading_card" style={{display: 'none'}}/></div>)
          )
        }

        <Button><Link to="/settings/payment-credits/card/add-new">Add Card</Link></Button>
      </div>


    );
  }
}


const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    cards: state.payment.cards
  }
}
export default connect(mapStateToProps, {getCards, setCardDefault})(CardSection)






// WEBPACK FOOTER //
// ./src/components/Settings/Dashboard/CardSection.js